// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"01ec3881","741":"129a381c"}[chunkId] + ".chunk.js";
};